import React, {FormEvent, useMemo, useState} from 'react'
import '../dashboard/view/index.css'
import Amazon from './assets/amazon.png'
import Booking from './assets/booking.png'
import Dell from './assets/dell.png'
import QuickBooks from './assets/quickbooks.png'
import {Modal, ModalBody} from 'react-bootstrap'
import FormPayment from '../become-merchant/components/Payment'
import MCLogo from '../../_metronic/assets/mc-logo.svg'

type ToolStatus = 'Connected' | 'Available'

type Tool = {
  name: string
  category: string
  logo?: any
  good?: string
  provider: string
  description: string
  status: ToolStatus
  statusClass: string
  actionClass: string
  actionLabel: string
  meta: string
  icon: string
  accent: string
  link: string
}

type PackageItem = {
  name: string
  subtitle: string
  price: string
  unit: string
  icon: string
  iconClass: string
  iconWrapClass: string
  buttonClass: string
  buttonLabel: string
  features: string[]
  highlight?: string
}

type RecentOrder = {
  title: string
  date: string
  amount: string
  status: string
  statusClass: string
  icon?: string
  iconText?: string
  iconWrapClass: string
  iconClass: string
}

const tools: Tool[] = [
  {
    name: 'Smart Business, Smarter Savings',
    logo: QuickBooks,
    category: 'Accounting',
    provider: 'By Intuit',
    description:
      'Manage your business finances smarter with industry-leading accounting software. Streamline your operations while reducing costs and saving time.',
    good: 'Up to 30% Off',
    status: 'Connected',
    statusClass: 'badge-light-success',
    actionClass: 'btn-light',
    actionLabel: 'Manage',
    meta: 'Last sync 2m ago',
    icon: 'bi-calculator',
    accent: '#3b82f6',
    link: 'https://quickbooks.intuit.com/global/pricing/',
  },
  {
    name: 'Summer Savings & Travel Rewards',
    logo: Booking,
    category: 'Reservations',
    provider: 'By Booking Holdings',
    description:
      'Find your perfect stay anywhere in the world and earn rewards on every booking. Plan your next getaway and enjoy extra value on every reservation.',
    good: 'Up to 8% Cashback',
    status: 'Connected',
    statusClass: 'badge-light-success',
    actionClass: 'btn-light',
    actionLabel: 'Manage',
    meta: '42 guests linked',
    icon: 'bi-calendar-check',
    accent: '#141413',
    link: 'https://www.booking.com/hotel/us/hyatt-place-new-york.html?label=en-tr-booking-desktop-9ZbdCGsyev990AqsyJeUWgS652828998844%3Apl%3Ata%3Ap1%3Ap2%3Aac%3Aap%3Aneg%3Afi%3Atikwd-65526620%3Alp9198790%3Ali%3Adec%3Adm&gclid=CjwKCAjw0dPRBhAPEiwAE5vTTntDYb5w7btETuJzjXIdrxV4Dzh9ga_Xyb8ZDk1HxREI-Bn_vxcr1BoCGv0QAvD_BwE&aid=2311236&ucfs=1&checkin=2026-06-22&checkout=2026-07-05&dest_id=929&dest_type=district&group_adults=2&no_rooms=1&group_children=0&srpvid=0ef23fff8bef017c&srepoch=1781860627&matching_block_id=46694108_431884107_2_1_0&atlas_src=sr_iw_title',
  },
  {
    name: 'Shop More, Save More',
    logo: Amazon,
    category: 'Marketplace',
    provider: 'By Amazon',
    description:
      'Save on top brands and everyday essentials across millions of products. Discover exclusive deals and make every purchase more rewarding.',
    good: 'Up to 15% Off',
    status: 'Available',
    statusClass: 'badge-light-warning',
    actionClass: 'btn-primary',
    actionLabel: 'Connect',
    meta: '~5 min setup',
    icon: 'bi-box-seam',
    accent: '#f37338',
    link: 'https://www.amazon.com/Apple-Version-Orange-Unlocked-Renewed/dp/B0FS9JLGXC/ref=sr_1_2?crid=MBU9QXYOALNX&dib=eyJ2IjoiMSJ9.nUWgXzJjvNEjv-8kIhK_sYrxAyaOQLTp9U5h0-wSmvd7sG-sqyeHVoqBFmPmGM304FAva7o8aNWMoGYDyjvs4TJiYVIfPu17tNzzNHXDCKuXa9LGE70Q1Dkg6buzxkDaHQxD8SpyibgWUvYby32_r7xGc30Aiy77moJiwAA23TUFlZye6vtIvKun1wycgT0Jt7rutRrQdPspOCPw4wY08wKDvl6ZZ5ZUwsbeLy2DbVo.bvpyljhxgKDlS4W9_fClgvFDWg7FskQNScxFc6a0B4w&dib_tag=se&keywords=iphone%2B17%2Bpro%2Bmax&qid=1781856506&sprefix=Iphone%2B17%2B%2Caps%2C227&sr=8-2&th=1',
  },
  {
    name: 'Power Up Your Productivity',
    logo: Dell,
    category: 'Procurement',
    provider: 'By Dell Technologies',
    description:
      'Discover powerful technology solutions for work, gaming, and productivity. Upgrade your setup with reliable devices designed to perform.',
    good: 'Up to 20% Off',
    status: 'Available',
    statusClass: 'badge-light-warning',
    actionClass: 'btn-primary',
    actionLabel: 'Connect',
    meta: 'Up to 20% off',
    icon: 'bi-laptop',
    accent: '#0ea5e9',
    link: 'https://www.dell.com/tr-tr/shop/cty/pdp/spd/dell-pro-pa14260-laptop',
  },
]

const packages: PackageItem[] = [
  {
    name: 'SMS Starter',
    subtitle: 'For small campaigns',
    price: '$29',
    unit: '/ 500 SMS',
    icon: 'bi-chat-dots',
    iconClass: 'text-info',
    iconWrapClass: 'bg-light-info',
    buttonClass: 'btn-light',
    buttonLabel: 'Buy package',
    features: ['500 SMS credits', 'Single sender ID', 'Delivery reports'],
  },
  {
    name: 'SMS Pro',
    subtitle: 'Best value - save 24%',
    price: '$99',
    unit: '/ 2,500 SMS',
    icon: 'bi-chat-square-dots-fill',
    iconClass: 'text-primary',
    iconWrapClass: 'bg-light-primary',
    buttonClass: 'btn-primary',
    buttonLabel: 'Buy package',
    features: ['2,500 SMS credits', 'Custom sender ID', 'Audience segmentation', 'Scheduled sends'],
    highlight: 'Most Popular',
  },
  {
    name: 'Email Essentials',
    subtitle: 'Newsletters & promos',
    price: '$19',
    unit: '/ 10,000 emails',
    icon: 'bi-envelope',
    iconClass: 'text-success',
    iconWrapClass: 'bg-light-success',
    buttonClass: 'btn-light',
    buttonLabel: 'Buy package',
    features: ['10,000 email sends', '3 templates included', 'Open & click tracking'],
  },
  {
    name: 'Combo Bundle',
    subtitle: 'SMS + Email together',
    price: '$129',
    unit: '/ month',
    icon: 'bi-stars',
    iconClass: 'text-warning',
    iconWrapClass: 'bg-light-warning',
    buttonClass: 'btn-light',
    buttonLabel: 'Buy bundle',
    features: [
      '2,500 SMS + 25,000 email',
      'Cross-channel automations',
      'A/B testing',
      'Priority support',
    ],
  },
]

const recentOrders: RecentOrder[] = [
  {
    title: 'SMS Pro - 2,500 credits',
    date: 'May 8 - #INV-2041',
    amount: '$99',
    status: 'Paid',
    statusClass: 'badge-light-success',
    icon: 'bi-chat-square-dots-fill',
    iconWrapClass: 'bg-light-primary',
    iconClass: 'text-primary',
  },
  {
    title: 'Email Essentials',
    date: 'May 4 - #INV-2034',
    amount: '$19',
    status: 'Paid',
    statusClass: 'badge-light-success',
    icon: 'bi-envelope',
    iconWrapClass: 'bg-light-success',
    iconClass: 'text-success',
  },
  {
    title: 'QuickBooks - Connection',
    date: 'Apr 28 - App install',
    amount: 'Free',
    status: 'Installed',
    statusClass: 'badge-light-info',
    iconText: 'QB',
    iconWrapClass: 'bg-success',
    iconClass: 'text-white',
  },
  {
    title: 'Booking.com - Connection',
    date: 'Apr 20 - App install',
    amount: 'Free',
    status: 'Installed',
    statusClass: 'badge-light-info',
    iconText: 'B.',
    iconWrapClass: 'bg-primary',
    iconClass: 'text-white',
  },
]

function SectionHeader({
  eyebrow,
  title,
  hint,
  action,
}: {
  eyebrow?: string
  title: string
  hint?: string
  action?: React.ReactNode
}) {
  return (
    <div className='d-flex align-items-end justify-content-between gap-4 flex-wrap mb-4'>
      <div>
        {eyebrow && (
          <div className='dashboard-apple-eyebrow text-uppercase fw-semibold mb-1'>{eyebrow}</div>
        )}
        <h2 className='fs-2 fw-bold text-gray-900 mb-0'>{title}</h2>
        {hint && <p className='fs-7 mb-0 mt-1 '>{hint}</p>}
      </div>
      {action}
    </div>
  )
}

function ToolCard({tool}: {tool: Tool}) {
  return (
    <button
      type='button'
      className='card dashboard-apple-hover h-100 text-start border border-gray-200 bg-white'
    >
      <div className='card-body p-6 d-flex justify-content-between align-items-center h-100'>
        <div className='d-flex align-items-center justify-content-between gap-5'>
          <span className='p-3 rounded border shadow-sm' style={{backgroundColor: '#F3F0EE'}}>
            <img
              src={tool.logo}
              width={75}
              height={75}
              className=''
              style={{
                objectFit: 'contain',
              }}
            />
          </span>

          <div className='d-flex flex-column justify-content-center'>
            <h3 className='fs-4 fw-bold text-gray-900'>{tool.name}</h3>
            <p className=''>{tool.description}</p>
            <p className=' text-secondary fw-bold'>{tool.good}</p>
          </div>
        </div>

        <div className='d-flex flex-column justify-content-center align-items-center'>
          {/*           <span className={`border-bottom border-2 border-secondary`}>{tool.status}</span>
           */}{' '}
          <a href={tool.link} target='blank' className='btn btn-link fw-bold p-0 text-secondary'>
            Detail <i className='bi bi-arrow-right ms-1 text-secondary'></i>
          </a>
        </div>
      </div>
    </button>
  )
}

function PackageCard({item}: {item: PackageItem}) {
  return (
    <div className={`card h-100 border shadow-sm position-relative`}>
      <div className='card-body p-7 d-flex flex-column gap-6'>
        <div className='d-flex align-items-center gap-4'>
          <div>
            <h5 className='text-secondary fw-bolder mb-1'>{item.name}</h5>
            <div className=' fs-7 fw-semibold'>{item.subtitle}</div>
          </div>
        </div>

        <div className='d-flex align-items-end gap-2'>
          <span className='text-dark fw-bolder' style={{fontSize: '2rem', lineHeight: 1}}>
            {item.price}
          </span>
          <span className=' fs-7 fw-semibold pb-1'>{item.unit}</span>
        </div>

        <div>
          <span className='fw-bold d-flex align-items-center gap-2'>
            <img src={MCLogo} height={13} />
            <span> Pay with your saved Mastercard and get 10% off instantly</span>
          </span>
        </div>

        <div className='d-flex flex-column gap-3'>
          {item.features.map((feature) => (
            <div key={feature} className='d-flex align-items-center gap-3'>
              <i className='bi bi-check-circle-fill text-success fs-5'></i>
              <span className='text-gray-700 fs-6 fw-semibold'>{feature}</span>
            </div>
          ))}
        </div>

        <div className='mt-auto pt-5 border-top border-gray-200'>
          <button type='button' className={`btn btn-primary w-50`}>
            Buy Now
          </button>
        </div>
      </div>
    </div>
  )
}

function UsageCard({
  title,
  value,
  meta,
  icon,
  wrapClass,
  iconClass,
}: {
  title: string
  value: string
  meta: string
  icon: string
  wrapClass: string
  iconClass: string
}) {
  return (
    <div className={`rounded p-5 mb-5 bg-light`}>
      <div className='d-flex align-items-center justify-content-between gap-3'>
        <div>
          <div className=' fs-7 fw-semibold mb-1'>{title}</div>
          <div className='text-dark fw-bolder fs-2'>{value}</div>
          <div className=' fs-8 mt-1'>{meta}</div>
        </div>
        <div className='symbol symbol-45px rounded-circle d-flex align-items-center justify-content-center bg-white'>
          <i className={`bi ${icon} fs-3 ${iconClass}`}></i>
        </div>
      </div>
    </div>
  )
}

function OrderRow({order, isLast}: {order: RecentOrder; isLast: boolean}) {
  return (
    <div
      className={`d-flex align-items-center gap-4  py-5 ${
        !isLast ? 'border-bottom border-gray-200' : ''
      }`}
    >
      <div className='flex-grow-1 min-w-0'>
        <div className='text-dark fw-bolder fs-6 text-truncate'>{order.title}</div>
        <div className=' fs-7'>{order.date}</div>
      </div>
      <div className='text-end'>
        <div className='text-dark fw-bolder fs-6 mb-2'>{order.amount}</div>
      </div>
    </div>
  )
}

const EStorePage: React.FC = () => {
  const [toolFilter, setToolFilter] = useState<'all' | 'connected' | 'available'>('all')

  const connectedCount = useMemo(
    () => tools.filter((tool) => tool.status === 'Connected').length,
    []
  )
  const availableCount = useMemo(
    () => tools.filter((tool) => tool.status === 'Available').length,
    []
  )

  const filteredTools =
    toolFilter === 'all'
      ? tools
      : tools.filter((tool) =>
          toolFilter === 'connected' ? tool.status === 'Connected' : tool.status === 'Available'
        )

  return (
    <div className='dashboard-apple-page estore-page'>
      <div className='d-flex align-items-end justify-content-between gap-5 flex-wrap'>
        <div>
          <div className='dashboard-apple-eyebrow text-uppercase fw-semibold mb-1'>Marketplace</div>
          <h1 className='fs-1 fw-bolder text-gray-900 mb-2'>E-Store</h1>
          <p className='fs-6 mb-0 '>
            Explore integrations and communication add-ons inside the Merchant Portal.
          </p>
        </div>
      </div>

      <div className='mt-10'>
        <div className='d-flex align-items-start justify-content-between gap-4 mb-6'>
          <div>
            <div className='dashboard-apple-eyebrow text-uppercase fw-semibold mb-1'>Add-ons</div>
            <h3 className='fs-3 fw-bold text-gray-900 mb-0'>SMS and E-mail packages</h3>
          </div>
        </div>

        <div className='row g-6'>
          {packages.map((item) => (
            <div key={item.name} className='col-12 col-md-3'>
              <PackageCard item={item} />
            </div>
          ))}
        </div>
      </div>

      <section className='mt-10'>
        <SectionHeader
          eyebrow='Apps'
          title='Efficiency & Productivity tools'
          hint=''
          action={
            <div className='d-flex flex-wrap gap-2'>
              <button
                type='button'
                className={`estore-filter-pill ${toolFilter === 'all' ? 'is-active' : ''}`}
                onClick={() => setToolFilter('all')}
              >
                All <span>{tools.length}</span>
              </button>
              <button
                type='button'
                className={`estore-filter-pill ${toolFilter === 'connected' ? 'is-active' : ''}`}
                onClick={() => setToolFilter('connected')}
              >
                Connected <span>{connectedCount}</span>
              </button>
              <button
                type='button'
                className={`estore-filter-pill ${toolFilter === 'available' ? 'is-active' : ''}`}
                onClick={() => setToolFilter('available')}
              >
                Available <span>{availableCount}</span>
              </button>
            </div>
          }
        />

        <div className='d-flex flex-column gap-4'>
          {filteredTools.map((tool) => (
            <ToolCard key={tool.name} tool={tool} />
          ))}
        </div>
      </section>
    </div>
  )
}

export default EStorePage
